<template>
  <div :class="$style.loader">
    <div :class="$style.spinner">
      <LoadingSpinner :size="60" />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@vue-pds/loading-spinner';

export default {
  name: 'Loading',
  components: {
    LoadingSpinner,
  },
};
</script>

<style lang="scss" module>

.loader {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  min-height: 880px;
  background: 50% 50% no-repeat rgba(255, 255, 255, 0.7);
  opacity: 0.8;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  margin: -25px 0 0 -25px;
}

.spinner > div {
  /* stylelint-disable */
  height: auto;
  /* stylelint-enable */
}
</style>
